/* =============================================================================
   SCROLL-BASED HEADER TEXT COLOUR
   Adds 'has-scrolled' class to .header when user scrolls past 10px.
   Fallback for draft preview where header.js 404s prevent is-sticky from firing.
   To remove: delete this block and remove .has-scrolled rule from custom.css
   ============================================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('theme-header .header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      header.classList.add('has-scrolled');
    } else {
      header.classList.remove('has-scrolled');
    }
  }, { passive: true });
});

/* =============================================================================
   CART DRAWER — REMOVE ITEM WHEN QUANTITY DECREMENTED TO ZERO
   ============================================================================= */
document.addEventListener('click', function(e) {
  const button = e.target.closest('.quantity.cart-update .minus');
  if (button) {
    const input = button.closest('.quantity').querySelector('.qty');
    if (input && parseInt(input.value) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const index = input.dataset.index;
      const item = button.closest('.product-cart-item');
      if (item) item.classList.add('thb-loading');

      const body = JSON.stringify({
        line: index,
        quantity: 0,
        sections: ['cart-drawer', 'cart-bubble'],
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body
      })
      .then(res => res.json())
      .then(parsedState => {
        if (parsedState.sections) {
          const drawerEl = document.getElementById('Cart-Drawer');
          if (drawerEl && parsedState.sections['cart-drawer']) {
            const parsed = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            const newInner = parsed.querySelector('#Cart-Drawer');
            if (newInner) {
              drawerEl.innerHTML = newInner.innerHTML;
            }
          }
        }
      });
    }
  }
}, true);
// === Mega menu — keep active on cursor move ===
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.thb-desktop-subnav__item.has-mega-menu');

  items.forEach(item => {
    const menu = item.querySelector('.mega-menu');
    if (!menu) return;

    let timeout;

    item.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      // Hide all menus first
      items.forEach(i => {
        const m = i.querySelector('.mega-menu');
        if (m) m.style.display = 'none';
      });
      menu.style.display = 'block';
    });

    item.addEventListener('mouseleave', (e) => {
      timeout = setTimeout(() => {
        if (!menu.matches(':hover')) {
          menu.style.display = 'none';
        }
      }, 100);
    });

    menu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
    });

    menu.addEventListener('mouseleave', () => {
      menu.style.display = 'none';
    });
  });
});
// === Header nav — switch text dark when scrolled ===
(function () {
  const header = document.querySelector('theme-header') || document.querySelector('.header');
  const navLinks = document.querySelectorAll('.thb-desktop-subnav__list a');

  if (!header || !navLinks.length) return;

  function updateNavColour() {
    const scrolled = window.scrollY > 50;
    navLinks.forEach(link => {
      if (scrolled) {
        link.style.setProperty('color', '#1a1714', 'important');
      } else {
        link.style.removeProperty('color');
      }
    });
  }

  window.addEventListener('scroll', updateNavColour, { passive: true });
  updateNavColour();
})();


